import React from 'react';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';

import User from '../user';

const Conversations = ({ t,
  sortedChannelIds,
  backgroundColor,
  startChat,
  messenger,
  loadMore,
  hasMore,
  activeId,
}) => (
  <div className="messenger-convs forscroll2 forscrollmessage">
    <InfiniteScroll
      loadMore={loadMore}
      hasMore={hasMore}
      pageStart={0}
      useWindow={false}
      initialLoad={false}
      loader={<div className="loader-conv" key="loader-conv">{t('Loading')} ...</div>}
    >
      {sortedChannelIds.map(channel => (
                messenger[channel].id !== undefined &&
                <a
                  href="#"
                  onClick={e => startChat(e, messenger[channel].id)}
                  key={messenger[channel].id}
                  className="full-width"
                >
                  <User
                    item={messenger[channel]}
                    classNaming="msg2box boxs"
                    backgroundColor={backgroundColor}
                    activeId={activeId}
                  />
                </a>
            ))}
    </InfiniteScroll>
  </div>


);

Conversations.propTypes = {
  t: PropTypes.func.isRequired,
  startChat: PropTypes.func.isRequired,
};

export default Conversations;



// WEBPACK FOOTER //
// ./src/views/modules/messages/startConversation/conversations/Conversations.jsx